import { FC } from 'react';

import Spotlight from '../FeaturedPosts/Spolight';
import Heading from '../Heading';
import PageGroup from '../PageGroup';
import PreHeading from '../PreHeading';
import Prose from '../Prose';

export interface StaffMegaMenuProps {
  dropdown: any;
}

const StaffMegaMenu: FC<StaffMegaMenuProps> = ({ dropdown }) => {
  console.log(dropdown);
  return (
    <div className="mega-menu mega-menu--service bg-theme-offwhite ring-white/20 lg:ring-1">
      <div className="grid p-0 lg:grid-cols-[1fr_1fr] lg:p-10">
        <div className="space-y-4 pb-0 sm:pb-6 lg:pr-20">
          {dropdown.pre_heading && (
            <PreHeading
              dot={true}
              size="md"
              element="h2"
              color="primary"
              className="font-normal"
            >
              {dropdown.pre_heading}
            </PreHeading>
          )}
          {dropdown.heading && (
            <Heading
              size="2xs"
              weight="semi"
              element={dropdown.pre_heading ? 'p' : 'h2'}
              className="hidden text-theme-darkgrey lg:inline"
            >
              {dropdown.heading}
            </Heading>
          )}
          <p className="text-theme-darkgrey">{dropdown.details}</p>
          {dropdown.content && (
            <Prose size={'md'} content={dropdown.content}></Prose>
          )}
        </div>
        <div className="grid-cols-2 gap-4 text-theme-darkgrey sm:grid md:gap-8 lg:gap-20">
          {dropdown.subpages.map((p) => {
            return <PageGroup key={p._uid} {...p} />;
          })}
        </div>
      </div>
      <div className="featured-posts border-t-slate-50 bg-theme-lightgrey p-4 text-theme-darkgrey md:p-8">
        <Spotlight posts={dropdown.featured} title={dropdown.featureTitle} />
      </div>
    </div>
  );
};

export default StaffMegaMenu;
